import React from "react";
import Layout from "../components/Layout";
import "../components/main.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import ContactForm from "../components/ContactForm";
import Nav from "../components/Nav";
import { Helmet } from "react-helmet";
const ContactPage = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <title>Contact page</title>
      </Helmet>
      <Layout>
        <Nav contact="nav-active" />
        <header class="header">
          <div className="black-overlay">
            <div class="container1" style={{ width: "100%", height: "100%" }}>
              <div className="header-text">
                <p className="header-p">GET 24/7 SUPPORT</p>
                <h1 className="header-h1">Contact us</h1>
              </div>
            </div>
          </div>
        </header>
        <section className="section-contact-form">
          <div className="container1">
            <div className="contact-form">
              <h2 className="h2">Have you any question?</h2>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. In
                aliquam sem fringilla ut morbi tincidunt augue interdum.
              </p>

              <ContactForm />
            </div>
            <div className="contact-info">
              <ul>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="map"
                    class="svg-inline--fa fa-map"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                  >
                    <path
                      fill="currentColor"
                      d="M0 114.4v349.5c0 11.32 11.49 19.04 22 14.84L160 416V32L10.06 99.59C3.984 102 0 107.9 0 114.4zM554 33.15L416 96v384l149.9-67.59C572 409.1 576 404.1 576 397.6V48.01C576 36.69 564.6 28.94 554 33.15zM192 415.1L384 480V95.1l-192.1-64L192 415.1z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <h4>Shop Address</h4>
                </li>
                <li>
                  <p>34/8, East Hukupara</p>
                </li>
                <li>
                  <p>Gifirtok, Sadan.</p>
                </li>
                <li>
                  <p>Country Name</p>
                </li>
              </ul>
              <ul>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="clock"
                    class="svg-inline--fa fa-clock"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <h4>Shop Hours</h4>
                </li>
                <li>
                  <p>MON - FRIDAY: 8 to 9 PM</p>
                </li>
                <li>
                  <p>SAT - SUN: 10 to 8 PM</p>
                </li>
              </ul>
              <ul>
                <li>
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="address-book"
                    class="svg-inline--fa fa-address-book"
                    role="img"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path
                      fill="currentColor"
                      d="M384 0H96C60.65 0 32 28.65 32 64v384c0 35.35 28.65 64 64 64h288c35.35 0 64-28.65 64-64V64C448 28.65 419.3 0 384 0zM240 128c35.35 0 64 28.65 64 64s-28.65 64-64 64c-35.34 0-64-28.65-64-64S204.7 128 240 128zM336 384h-192C135.2 384 128 376.8 128 368C128 323.8 163.8 288 208 288h64c44.18 0 80 35.82 80 80C352 376.8 344.8 384 336 384zM496 64H480v96h16C504.8 160 512 152.8 512 144v-64C512 71.16 504.8 64 496 64zM496 192H480v96h16C504.8 288 512 280.8 512 272v-64C512 199.2 504.8 192 496 192zM496 320H480v96h16c8.836 0 16-7.164 16-16v-64C512 327.2 504.8 320 496 320z"
                    ></path>
                  </svg>
                </li>
                <li>
                  <h4>Contact</h4>
                </li>
                <li>
                  <p>Phone: +00 111 222 3333</p>
                </li>
                <li>
                  <p>Email: support@fruitkha.com</p>
                </li>
              </ul>
            </div>
          </div>
        </section>
        <section className="map-section">
          <div className="container1">
            <div className="map-header">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="location-dot"
                class="svg-inline--fa fa-location-dot"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
              >
                <path
                  fill="currentColor"
                  d="M192 0C85.97 0 0 85.97 0 192c0 77.41 26.97 99.03 172.3 309.7c9.531 13.77 29.91 13.77 39.44 0C357 291 384 269.4 384 192C384 85.97 298 0 192 0zM192 271.1c-44.13 0-80-35.88-80-80S147.9 111.1 192 111.1s80 35.88 80 80S236.1 271.1 192 271.1z"
                ></path>
              </svg>
              <h2 className="h2">Find Our Location</h2>
            </div>
          </div>
          <div className="map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4672.408353025696!2d-118.31658676141244!3d34.097916523828346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2bf488e4bdebd%3A0xc4c51c6cc579bbc3!2s1546%20Gordon%20St%2C%20Los%20Angeles%2C%20CA%2090028%2C%20USA!5e0!3m2!1sen!2sua!4v1636925520006!5m2!1sen!2sua"
              width="100%"
              height="800"
              style={{ border: "0" }}
              allowfullscreen=""
              loading="lazy"
            ></iframe>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default ContactPage;
